import { render } from "./DashboardTab.vue?vue&type=template&id=1aad25c1&scoped=true"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"

import "./DashboardTab.vue?vue&type=style&index=0&id=1aad25c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aad25c1"]])

export default __exports__